import React  from "react";
import Styles from "./styles.module.scss";
import Toggle from "../../compopnents/toggleButton";
import classnames from "classnames";
import FormHead from "../../compopnents/headings/FromHead";

function GeneralSettings(props: any) {

  const customerId = localStorage.getItem('customerId')
  const userLoginId = localStorage.getItem('loginId')

  const toggleChange = (e: any) => {
    
    let body = {
      'showRateInEmail': e.value,
      'customerId': customerId,
      'userLoginId': userLoginId
    }
    props.showrateInMail(body)
  }
  
  return (
    <div>
      <div className="form-group">
        <figure className={Styles.uploadPicWrap}>
        {props.defImage ? <img src={props.defImage} alt=""/> :
          <span className={Styles.noPicWrap}>{props.companyName && props.companyName[0]}{props.companyName && props.companyName[1]}</span>
        }
        </figure>
      </div>
      <FormHead>General Settings</FormHead>
      <div className="form-group mb-4">
        <div className={classnames("lablel", Styles.candidateWrap)}>
          <span>Show candidate rate in the mail ?</span>
          <div className={Styles.tggleBtn}>
            <Toggle onChange={toggleChange} defaultChecked={props.defaultValues} />
          </div>
        </div>
        <label className="lablel">
          Candidate rate will be included in the emails received from ellow.io
        </label>
      </div>
    </div>
  )
}

export default GeneralSettings;
